export enum UserStatus {
  Active = 'active',
  Pending = 'pending',
  Deactivated = 'deactivated',
  Deleted = 'deleted',
  Online = 'online',
  Idle = 'idle',
  Offline = 'offline',
}

export interface IUsers {
  id?: string;
  first_name: string;
  last_name: string;
  email: string;
  profile_photo: any | null;
}

export interface IUsersResponse {
  total_items?: number;
  total_pages?: number;
  page?: number;
  limit?: number;
  items?: IUser[];
}

export interface IUserDetail extends IUsers {
  status?: UserStatus;
  active_date: string | null;
  deactivated_date: string | null;
  pending_date: string | null;
}

export interface IUser {
  id?: string;
  created_at?: string;
  updated_at?: string;
  // org_id: string
  first_name?: string;
  last_name?: string;
  display_name?: string;
  username?: string;
  phone?: string;
  email?: string;
  role?: string;
  status?: string;
  items_per_page?: number;
  avatar?: string;
  avatar_type?: string;
  teams?: any[];
  tooltip?: IUserTooltip;
  timezone?: string;
  profile_photo?: string;
  timezoneType?: 'auto' | 'manual' | '';
  delivery?: Delivery;
  notification_setting?: {
    url: string;
    repeatingInterval: number | string;
    mute: boolean;
    task_update: {
      enable: boolean;
      duration: number;
    };
    import_csv: {
      enable: boolean;
      duration: number;
    };
    new_driver: {
      enable: boolean;
      duration: number;
    };
  };
}

export interface Delivery {
  enable_delivery: boolean;
  delivery_hours?: DeliveryHours;
  special_hours?: SpecialHour[];
}

export interface DeliveryHours {
  monday?: DateElement;
  tuesday?: DateElement;
  wednesday?: DateElement;
  thursday?: DateElement;
  friday?: DateElement;
  saturday?: DateElement;
  sunday?: DateElement;
}

export interface DateElement {
  all_hour?: boolean;
  available?: boolean;
  shifts?: ShiftElement[];
}

export interface ShiftElement {
  start_time: string;
  end_time: string;
  pause_assign?: string;
}

export interface SpecialHour {
  start_date: Date;
  end_date: Date;
  name: string;
  shifts?: ShiftElement[];
  available?: boolean;
  all_hour?: boolean;
}

export interface IUserTooltip {
  task_list?: boolean;
  create_task?: boolean;
  invite_driver?: boolean;
  online_driver?: boolean;
  view_specific_info?: boolean;
  assign_task?: boolean;
  check_ideal_route?: boolean;
  enter_task_details?: boolean;
  assign_task_create?: boolean;
  organization?: boolean;
  stores?: boolean;
  optimize_store?: boolean;
  drivers?: boolean;
  manage_driver?: boolean;
  teams?: boolean;
  users?: boolean;
  set_task_routes?: boolean;
  add_store?: boolean;
}
